import { SmoothScroll } from "@/components/site/SmoothScroll";
import { PlayerProvider } from "@/context/PlayerContext";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Catalog } from "@/components/site/Catalog";
import { Manifesto } from "@/components/site/Manifesto";
import { Artists } from "@/components/site/Artists";
import { Footer } from "@/components/site/Footer";
import { PlayerBar } from "@/components/site/PlayerBar";

export default function Home() {
  return (
    <PlayerProvider>
      <SmoothScroll>
        <div className="grain-overlay" />
        <div className="relative bg-void min-h-screen overflow-x-hidden">
          <Nav />
          <main>
            <Hero />
            <Marquee variant="solid" />
            <Catalog />
            <Marquee variant="outline" />
            <Manifesto />
            <Artists />
            <Footer />
          </main>
          <PlayerBar />
        </div>
      </SmoothScroll>
    </PlayerProvider>
  );
}
